/** Resolved by the app's alert display. This is a message key, not display copy. */
export const DELETE_QUEUE_FAILED_MESSAGE_KEY = 'deleteQueueFailed';
